import { CALL_API } from '../../api';
import * as ActionTypes from './user.actionTypes';
import * as TeamActions from '../team/team.actions';
import schema from '../../api/schema';

export const invalidateUser = (id) => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.INVALIDATE_USER,
    payload: {
      id
    }
  });

  return dispatch(readUser(id));
};

export const invalidateCurrentUser = () => (dispatch, getState) => {
  const id = getState().auth.user;
  dispatch({
    type: ActionTypes.INVALIDATE_USER,
    payload: {
      id
    }
  });

  return dispatch(readUser(id));
};

const doValidateEmailToken = (emailToken) => ({
  [CALL_API]: {
    types: [
      ActionTypes.VALIDATE_EMAIL_TOKEN_REQUEST,
      ActionTypes.VALIDATE_EMAIL_TOKEN_SUCCESS,
      ActionTypes.VALIDATE_EMAIL_TOKEN_FAILURE,
    ],
    endpoint: `api/general/validateToken/${emailToken}`,
  }
});

export const validateEmailToken = (emailToken) => (dispatch, getState) => {
  return dispatch(doValidateEmailToken(emailToken));
};

const readUsers = () => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_USERS_REQUEST,
      ActionTypes.READ_USERS_SUCCESS,
      ActionTypes.READ_USERS_FAILURE,
    ],
    endpoint: 'api/users',
    schema: schema.usersSchema,
    authorization: true,
  }
});

export const getUsers = () => (dispatch, getState) => {
  return dispatch(readUsers());
};

const readUser = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_USER_REQUEST,
      ActionTypes.READ_USER_SUCCESS,
      ActionTypes.READ_USER_FAILURE,
    ],
    endpoint: `api/users/${id}`,
    schema: schema.userSchema,
    authorization: true,
  },
  payload: {
    id
  }
});

export const getUser = (id) => (dispatch, getState) => {
  const user = getState().entities.user.byId[id];
  if (user) {
    return Promise.resolve();
  }
  return dispatch(readUser(id));
};

const doCreateUser = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.CREATE_USER_REQUEST,
      ActionTypes.CREATE_USER_SUCCESS,
      ActionTypes.CREATE_USER_FAILURE,
    ],
    endpoint: 'api/users/',
    schema: schema.userSchema,
    authorization: true,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  }
});

export const createUser = (data) => (dispatch, getState) => {
  return dispatch(doCreateUser(data)).then((response) => {
    if(!response.error) {
      dispatch(
        TeamActions.invalidateTeam(response.response.entities.user[response.response.result].team)
      );
    }
    return response;
  });
};

const doUpdateUser = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.UPDATE_USER_REQUEST,
      ActionTypes.UPDATE_USER_SUCCESS,
      ActionTypes.UPDATE_USER_FAILURE,
    ],
    endpoint: `api/users/${data._id}`,
    schema: schema.userSchema,
    authorization: true,
    requestInit: {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  },
  payload: {
    id: data._id
  }
});

export const updateUser = (data) => (dispatch, getState) => {
  return dispatch(doUpdateUser(data));
};

export const registerUser = (authToken, data) => (dispatch, getState) => {
  localStorage.setItem('cmore-sisapiiri-token', authToken);
  return dispatch(doUpdateUser(data)).then(
    response => {
      if(response.type === ActionTypes.UPDATE_USER_SUCCESS) {
        //TODO Centralized token handling
      } else {
        //TODO Centralized token handling
        localStorage.removeItem('cmore-sisapiiri-token');
      }
      return Promise.resolve();
    }
  );
};

const doDeleteUser = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.DELETE_USER_REQUEST,
      ActionTypes.DELETE_USER_SUCCESS,
      ActionTypes.DELETE_USER_FAILURE,
    ],
    endpoint: `api/users/${id}`,
    schema: schema.userSchema,
    authorization: true,
    requestInit: {
      method: 'DELETE',
    },
  },
  payload: {
    id
  }
});

export const deleteUser = (id) => (dispatch, getState) => {
  return dispatch(doDeleteUser(id));
};

export const searchUsers = () => {

};

const doChangePassword = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.CHANGE_PASSWORD_REQUEST,
      ActionTypes.CHANGE_PASSWORD_SUCCESS,
      ActionTypes.CHANGE_PASSWORD_FAILURE,
    ],
    endpoint: `api/users/${data._id}/password`,
    authorization: true,
    authFailHandling: true,
    requestInit: {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  },
  payload: {
    id: data._id
  }
});

export const changePassword = (data) => (dispatch, getState) => {
  return dispatch(doChangePassword(data));
};

const doResetPassword = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.RESET_PASSWORD_REQUEST,
      ActionTypes.RESET_PASSWORD_SUCCESS,
      ActionTypes.RESET_PASSWORD_FAILURE,
    ],
    endpoint: `api/general/password/${data.emailToken}`,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  }
});

export const resetPassword = (data) => (dispatch, getState) => {
  return dispatch(doResetPassword(data));
};

const doForgotPassword = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.RESET_PASSWORD_REQUEST,
      ActionTypes.RESET_PASSWORD_SUCCESS,
      ActionTypes.RESET_PASSWORD_FAILURE,
    ],
    endpoint: `api/general/resetPassword`,
    authFailHandling: true,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  }
});

export const forgotPassword = (data) => (dispatch, getState) => {
  return dispatch(doForgotPassword(data));
};


// WEBPACK FOOTER //
// ./src/modules/user/user.actions.js